// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__n9iz_","header":"ReportDetails_header__2uGeI","title":"ReportDetails_title__2SIf4","left":"ReportDetails_left__st3N7"};